export default __webpack_public_path__ + "static/media/gallary8.eae306ab.jpg";